<template>
  <div>
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3715.3914042406373!2d-42.68813854353845!3d-21.374487885195457!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xa2d0c79ea107c9%3A0x4f28eff247f5142e!2sR.%20das%20Ac%C3%A1cias%2C%20700%20-%20Pouso%20Alegre%2C%20Cataguases%20-%20MG!5e0!3m2!1spt-BR!2sbr!4v1692964457134!5m2!1spt-BR!2sbr"
      :width="mapSizeWidth"
      :height="mapSizeHeight"
      style="
        border: 0;
        box-shadow: 2.6px 2.6px 5.3px 0px rgba(0, 0, 0, 0.6);
        border-radius: 6px;
      "
      allowfullscreen=""
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"
    ></iframe>
  </div>
</template> 

<script>
export default {
  name: "Map",
  data() {
    return {
      screenWidth: window.innerWidth,
    };
  },
  computed: {
    mapSizeWidth() {
      if (this.screenWidth < 1500 && this.screenWidth > 1300) {
        console.log(this.screenWidth);
        return 600;
      } else if (this.screenWidth <= 1300 && this.screenWidth > 1120) {
        return 550;
      } else if (this.screenWidth <= 1120 && this.screenWidth > 560) {
        return 430;
      } else if (this.screenWidth <= 560) {
        return 325;
      } else {
        return 700;
      }
    },
    mapSizeHeight() {
      if (this.screenWidth < 1500 && this.screenWidth > 1300) {
        return 428;
      } else if (this.screenWidth <= 1300 && this.screenWidth > 1120) {
        return 392;
      } else if (this.screenWidth <= 1120 && this.screenWidth > 560) {
        return 392;
      } else if (this.screenWidth <= 560) {
        return 400;
      } else {
        return 500;
      }
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.screenWidth = window.innerWidth;
      this.screenHeight = window.innerHeight;
    },
  },
};
</script>
